import { useParams } from "react-router-dom";
import "./certificate.css";
import { getJournalDetailsById } from "src/network/api";
import { useEffect, useState } from "react";
import { STATIC } from "src/network/networkConfig";
import logo from "src/assets/img/logo192.png";

const JournalCertificate = () => {
  const [journal, setJournal] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    const fetchJournal = async () => {
      try {
        setLoading(true);
        const response = await getJournalDetailsById(id);
        setJournal(response.data.data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchJournal();
  }, [id]);

  if (loading)
    return (
      <div className="d-flex justify-content-center mt-5">
        <div className="loader mt-5"></div>
      </div>
    );
  if (error) return <p>Error: {error}</p>;
  if (!journal) return <p>No data available.</p>;

  return (
    <div
      className="certificate-main-container"
      style={{ width: "800px", margin: "20px auto" }}
    >
      <div
        className="pm-certificate-container"
        style={{ backgroundImage: `url("${STATIC.frameImageURL}")` }}
      >
        <div className="pm-certificate-border col-xs-12">
          <div className="logo-container">
            <img src={logo} alt="Logo" className="certificate-logo" />
          </div>
          {/* Certificate Header */}
          <div className="pm-certificate-header">
            <div className="pm-certificate-title cursive col text-center">
              <h2>International Faculty Research and Journal Index</h2>
            </div>
          </div>

          <h1 className="text-center" style={{ fontWeight: "bold" }}>
            CERTIFICATE OF JOURNAL
          </h1>

          {/* Certificate Body */}
          <div className="pm-certificate-body d-flex justify-content-center">
            <div className="pm-certificate-block">
              {/* Certificate Holder's Name */}
              <div className="col-xs-12 text-center">
                <span className="pm-label">
                  THIS CERTIFICATE IS PROUDLY AWARDED TO
                </span>
                <div className="pm-name-container mt-3">
                  <h2 className="pm-name-text bold">
                    {journal.journal_name || "N/A"}
                  </h2>
                  <hr className="pm-underline" />
                </div>
              </div>

              {/* Completion Notification */}
              <div className="col-xs-12 text-center">
                <span
                  className="pm-earned-text block"
                  style={{ textAlign: "justify" }}
                >
                  WE HEREBY NOTIFY THAT THE JOURNAL ABOVE HAS BEEN REGISTERED ON
                  IFRJ INDEX. WE ARE GRATEFUL TO{" "}
                  <h6
                    style={{
                      textTransform: "uppercase",
                      margin: 0,
                      display: "inline",
                      fontWeight: "bold",
                    }}
                  >
                    {journal.journal_name}
                  </h6>{" "}
                  FOR REGISTERING WITH US.{" "}
                </span>
                <div className="logo-bottom-right">
                  <p className="issuer-text">Issuer: Team IFRJ Index</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JournalCertificate;
